/**
 * Extracts a user-friendly error message from an error object
 *
 * @param {Error|Object} error - The error object from API call
 * @param {string} defaultMessage - Default message to show if no specific error is found
 * @returns {string} The formatted error message
 */
export function getErrorMessage(error, defaultMessage) {
    if (error?.response?.data?.message) {
        return error.response.data.message + '. ' + defaultMessage;
    }
    if (error?.message) {
        return error.message + ', ' + defaultMessage;
    }
    return defaultMessage;
}
